import {
  HOME_TYPES_ALL,
  HOME_TYPES_HOUSE,
  HOME_TYPES_LOTLAND,
  HOME_TYPES_APTCONDO,
  HOME_TYPES_TOWNHOUSE,
} from '../../../../constants/listings'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'
import { FilterCheckBox } from '../FilterCheckBox'

import styles from './HomeType.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.homeType.heading',
    defaultMessage: 'Home type',
  },
  all: {
    id: 'HomeSearch.listings.filters.homeType.all',
    defaultMessage: 'All',
  },
  house: {
    id: 'HomeSearch.listings.filters.homeType.house',
    defaultMessage: 'House',
  },
  aptCondo: {
    id: 'HomeSearch.listings.filters.homeType.aptCondo',
    defaultMessage: 'Apartment / Condo',
  },
  townhouse: {
    id: 'HomeSearch.listings.filters.homeType.townhouse',
    defaultMessage: 'Townhouse',
  },
  lotLand: {
    id: 'HomeSearch.listings.filters.homeType.lotLand',
    defaultMessage: 'Lot / Land',
  },
})

export const HomeType = () => {
  const intl = useIntl()
  const { propertyTypes } = useSelector(selectFilter)
  const [all, setAll] = useState(propertyTypes.length === 0)
  const [apt, setApt] = useState(propertyTypes.includes(HOME_TYPES_APTCONDO))
  const [twn, setTwn] = useState(propertyTypes.includes(HOME_TYPES_TOWNHOUSE))
  const [land, setLand] = useState(propertyTypes.includes(HOME_TYPES_LOTLAND))
  const [house, setHouse] = useState(propertyTypes.includes(HOME_TYPES_HOUSE))

  useEffect(() => {
    setAll(!house && !land && !apt && !twn)
  }, [house, apt, twn, land])

  const handleSelectAll = () => {
    setAll(true)
    setApt(false)
    setTwn(false)
    setLand(false)
    setHouse(false)
  }

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <fieldset className={styles.checkBoxFields}>
        <FilterCheckBox
          isChecked={all}
          name={HOME_TYPES_ALL}
          onChange={handleSelectAll}
          label={intl.formatMessage(MSG.all)}
        />
        <FilterCheckBox
          isChecked={house}
          name={HOME_TYPES_HOUSE}
          onChange={() => setHouse(!house)}
          label={intl.formatMessage(MSG.house)}
        />
        <FilterCheckBox
          isChecked={apt}
          name={HOME_TYPES_APTCONDO}
          onChange={() => setApt(!apt)}
          label={intl.formatMessage(MSG.aptCondo)}
        />
        <FilterCheckBox
          isChecked={twn}
          name={HOME_TYPES_TOWNHOUSE}
          onChange={() => setTwn(!twn)}
          label={intl.formatMessage(MSG.townhouse)}
        />
        <FilterCheckBox
          isChecked={land}
          name={HOME_TYPES_LOTLAND}
          onChange={() => setLand(!land)}
          label={intl.formatMessage(MSG.lotLand)}
        />
      </fieldset>
    </FilterSection>
  )
}
